// Debounce function for performance optimization
function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}
// CartRemoveButton Class - Handles removal of products from the cart
class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            // cartItems.updateQuantity(this.dataset.index, 0);
            const productId = this.dataset.productId; 
            console.log('Product ID from remove button:', productId);
            if (cartItems && productId) {
                cartItems.removeLineItems(productId); 
            } else {
                console.error('No cartItems or productId found');
            }
        });
    }
}
customElements.define('cart-remove-button', CartRemoveButton);
// CartItems Class - Handles cart interactions and updates
class CartItems extends HTMLElement {
    constructor() {
        super();
        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
            .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));

        const gift_form_minicart = document.getElementById("gift_form_minicart");
        if (gift_form_minicart) {
            gift_form_minicart.addEventListener("change", (event) => {
                if (event.currentTarget.checked) {
                    this.addGiftwrapCartClick(gift_form_minicart);
                } else {
                    this.updateQuantity(event.currentTarget.dataset.index, 0);
                }
            });
        }
        document.querySelectorAll('.bls__js-addtocart-page').forEach(
            (upsell) => upsell.addEventListener('click', this.addProductUpSellEvent.bind(this))
        );
    }
    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.dataset.key, event.target.value, document.activeElement.getAttribute('name'));
    }
    getSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents',
            }
        ];
    }
    updateQuantity(line, key, quantity, name) {
    quantity = quantity ? quantity : 0;
    this.enableLoading(line);

    const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((state) => {
            const parsedState = JSON.parse(state);
            this.updateCart(parsedState); // Update the cart UI dynamically
        })
        .catch(() => {
            this.disableLoading();
        })
        .finally(() => {
            BlsLazyloadImg.init();
        });
}
removeLineItems(productId) {
    console.log('Attempting to remove line item with ID:', productId);  // Debugging log

    // Fetch the current cart state
    fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
            const updates = {};

            // Find the main product by its product_id
            const mainProduct = cart.items.find((item) => item.product_id == productId);
            if (mainProduct) {
                const mainProductSku = mainProduct.sku;

                // Loop through cart items to find related items by SKU
                cart.items.forEach((item) => {
                    if (item.properties && item.properties.sku && item.properties.sku == mainProductSku) {
                        updates[item.id] = 0; // Remove this item
                    }
                });
                // Add main product to updates as well (in case it's also part of the same SKU group)
                updates[mainProduct.id] = 0;
                console.log('Updates object before sending:', updates);  // Debugging log
                // Make the API call to update the cart with the new line item values
                const body = JSON.stringify({
                    updates,
                    sections: this.getSectionsToRender().map((section) => section.section),
                    sections_url: window.location.pathname
                });

                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
                    .then((response) => response.json())  // Ensure response is parsed as JSON
                    .then((parsedState) => {
                        console.log('Parsed state after update:', parsedState); // Debugging log
                        this.updateCart(parsedState); // Update the cart UI dynamically

                        // Force a reload after cart is updated successfully
                        window.location.reload();
                    })
                    .catch((error) => {
                        console.error('Error updating cart after removal:', error);
                    });
            } else {
                console.error('Product ID not found in cart:', productId);
            }
        })
        .catch((err) => {
            console.error('Error fetching cart:', err);
        });
}
updateCart(parsedState) {
    console.log('Updating cart with state:', parsedState);  // Debugging log

    if (parsedState.item_count !== undefined) {
        document.querySelectorAll(".cart-count").forEach(el => {
            if (el.classList.contains('cart-count-drawer')) {
                el.innerHTML = parsedState.item_count;
            } else {
                el.innerHTML = parsedState.item_count;
            }
        });

        if (document.querySelector('header-total-price')) {
            document.querySelector('header-total-price').updateTotal(parsedState);
        }

        // Debugging: Check the structure of the parsedState.sections object
        console.log('Sections in parsedState:', parsedState.sections);

        // Check if the specific section we want is available in the response
        const sectionHtml = parsedState.sections[document.getElementById('main-cart-items').dataset.id];
        if (!sectionHtml) {
            console.error('Section not found in parsedState:', document.getElementById('main-cart-items').dataset.id);
            return; // Prevent further execution if section not found
        }

        const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const elementToReplace = document.getElementById('main-cart-items');

        if (!elementToReplace) {
            console.error('Element to replace not found: #main-cart-items');
            return; // Prevent further execution if the element to replace is missing
        }

        const newContents = html.querySelector('.js-contents');
        if (!newContents) {
            console.error('Could not find .js-contents in parsed state');
            return; // Prevent further execution if .js-contents is missing
        }

        elementToReplace.innerHTML = newContents.innerHTML;
        BlsLazyloadImg.init(); // Reinitialize images if necessary
    } else {
        console.error('Parsed state does not contain item_count:', parsedState);  // Debugging log
    }
}



    // Method to add giftwrap to cart
    addGiftwrapCartClick(event) {
        const target = event;
        const variant_id = target.getAttribute('data-variant-id');
        const body = JSON.stringify({
            id: Number(variant_id),
            quantity: 1,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => response.text())
        .then((state) => {
            const parsedState = JSON.parse(state);
            fetch('/cart.json')
            .then(res => res.json())
            .then(cart => {
                if (cart.item_count != undefined) {
                    document.querySelectorAll(".cart-count").forEach(el => {
                        if (el.classList.contains('cart-count-drawer')) {
                            el.innerHTML = `(${cart.item_count})`;
                        } else {
                            el.innerHTML = cart.item_count;
                        }
                    });
                    if (document.querySelector('header-total-price')) {
                        document.querySelector('header-total-price').updateTotal(cart);
                    }
                }
            })
            .catch((error) => {
                throw error;
            });
            const html = new DOMParser().parseFromString(parsedState.sections[document.getElementById('main-cart-items').dataset.id], 'text/html');
            if (parsedState.item_count == 0) {
                this.getSectionsToRender().forEach((section => {
                    const elementToReplace = document.querySelector('.cart-wrapper');
                    elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], '.cart-wrapper');
                }));
            } else {
                this.getSectionsToRender().forEach((section => {
                    const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));
            }
            this.disableLoading();
            BlsLazyloadImg.init();
        }).catch(() => {
            this.disableLoading();
        });
    }
    // Method to add upsell products to the cart
    addProductUpSellEvent(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const variant_id = target.closest('.bls__product-addtocart-js').getAttribute('data-product-variant-id');
        const body = JSON.stringify({
            id: Number(variant_id),
            quantity: 1,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);
            this.updateCart(parsedState);
        })
        .catch((error) => {
            console.error('Error adding upsell product:', error);
        });
    }
    enableLoading(line) {
        const loader = document.querySelector(`#product-line-${line} .cart-item-loader`);
        if (loader) {
            loader.classList.add('loading');
        }
    }

    disableLoading() {
        const loaders = document.querySelectorAll('.cart-item-loader');
        loaders.forEach(loader => loader.classList.remove('loading'));
    }
}
customElements.define('cart-items', CartItems);

class CartPageUpsell extends CartItems {
    constructor() {
      super();
    }
    init(){
      this.connectedCallback();
    }
    connectedCallback() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.swiper-wrapper');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.querySelector(".swiper-wrapper").innerHTML = recommendations.innerHTML;
          }
        })
        .finally(() =>{
          BlsSettingsSwiper.init();
          BlsLazyloadImg.init()
          document.querySelectorAll('.bls__js-addtocart-page').forEach(
            (upsell) => upsell.addEventListener('click', this.addProductUpSellEvent.bind(this))
        );
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
customElements.define('minicart-recommendations-page', CartPageUpsell);

if (!customElements.get('cart-note')) {
    customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
      }
    });
};
  